import { useState } from "react";
import { toast } from "sonner";
import { Wifi, Eye, RotateCcw, Copy } from "lucide-react";
import api from "../lib/api";

export function WifiPasscode({ companyId, email }) {
  const [code, setCode] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (reset) => {
    if (reset && !window.confirm(`Reset the WiFi passcode for ${email}? Their current passcode stops working on all their devices.`)) return;
    setBusy(true);
    try {
      const { data } = reset
        ? await api.post(`/members/${companyId}/wifi-passcode/reset`, null, { params: { email } })
        : await api.get(`/members/${companyId}/wifi-passcode`, { params: { email } });
      setCode(data.passcode);
      if (reset) toast.success("New WiFi passcode created", { description: "Share it with the member — the old one no longer works." });
    } catch (e) { toast.error(reset ? "Couldn't reset passcode" : "Couldn't get passcode", { description: e.userMessage }); }
    finally { setBusy(false); }
  };
  const btn = "inline-flex items-center gap-1 text-[11px] text-brand-muted hover:text-brand-primary transition-colors disabled:opacity-50";
  return (
    <span className="inline-flex items-center gap-3 ml-auto" data-testid={`wifi-${email}`}>
      <Wifi className="h-3 w-3 text-brand-tertiary" />
      {code ? (
        <>
          <code className="text-xs text-brand-ink bg-brand-hover px-1.5 py-0.5 rounded" data-testid={`wifi-code-${email}`}>{code}</code>
          <button className={btn} onClick={() => { navigator.clipboard?.writeText(code); toast.success("Passcode copied"); }} data-testid={`wifi-copy-${email}`}><Copy className="h-3 w-3" /> Copy</button>
        </>
      ) : (
        <button className={btn} disabled={busy} onClick={() => run(false)} data-testid={`wifi-show-${email}`}><Eye className="h-3 w-3" /> WiFi passcode</button>
      )}
      <button className={btn} disabled={busy} onClick={() => run(true)} data-testid={`wifi-reset-${email}`}><RotateCcw className="h-3 w-3" /> Reset</button>
    </span>
  );
}
